import { defineStore } from 'pinia'
import { useFormStore } from '@/features/blueprint/stores/useFormStore'

export const useScoreStore = defineStore('score', {
    state: () => ({
        totalPoints: 0,
        sectionScores: {} as Record<string, number>,
    }),

    getters: {
        progress(state) {
            return Math.min(100, state.totalPoints)
        },
    },

    actions: {
        recalculate() {
            const form = useFormStore()
            let total = 0
            const sectionScores: Record<string, number> = {}

            // flatten all questions once
            const allQuestions = form.sections.flatMap(s => s.questions)

            for (const [questionId, answer] of Object.entries(form.answers)) {
                // 1) find the question so we know its possible points
                const question = allQuestions.find(q => q.id === questionId)
                const maxPts = question?.points ?? 0

                // 2) decide if “answered” at all
                const counted =
                    // non-empty string
                    (typeof answer === 'string' && answer.trim() !== '') ||

                    // non-empty array *with at least one non-empty item*
                    (Array.isArray(answer) &&
                        answer.some(item =>
                            // if it’s a string, trim out blanks
                            typeof item === 'string'
                                ? item.trim() !== ''
                                : // otherwise just check non-null
                                item != null
                        )) ||

                    // true checkbox
                    (typeof answer === 'boolean' && answer) ||

                    // any other non-null / undefined value
                    (answer != null &&
                        typeof answer !== 'string' &&
                        !Array.isArray(answer) &&
                        typeof answer !== 'boolean')

                // 3) award either maxPts or zero
                const awarded = counted ? maxPts : 0
                sectionScores[questionId] = awarded
                total += awarded
            }

            this.totalPoints = total
            this.sectionScores = sectionScores
        },
    },
})
